// extracted by mini-css-extract-plugin
export default {"loaderContainer":"IBANContainer_loaderContainer__VA6+9","loader":"IBANContainer_loader__tXxGv","iban":"IBANContainer_iban__cP699"};